import React from 'react';
import {faGithub, faLinkedin, faTwitter} from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import './style.css'

function Footer() {
    return(
        <div className="Footer">
             <p className="Footer__title">About</p>
            <p className="Footer__info" >Pokedex developed using React and <a href="https://pokeapi.co/docs/v2" target="_blank" rel="noreferrer">pokeapi</a>. Go & check out your favourtite pokemons</p>
            <ul className="Footer__list">
                <li className="list__item__inline" >
                    <a href="https://twitter.com/SuhasKadu1/" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon className="social__media__icon"
                        icon={faTwitter} /></a>
                </li>
                <li className="list__item__inline" >
                    <a href="https://github.com/suhas-kadu" target="_blank" rel="noreferrer">
                        <FontAwesomeIcon className="social__media__icon"
                        icon={faGithub} /></a>
                </li>
                <li className="list__item__inline" >
                    <a href="https://in.linkedin.com/in/suhas-kadu-12b1a51ab" target="_blank" rel="noreferrer"
                    ><FontAwesomeIcon className="social__media__icon"
                        icon={faLinkedin} /></a>
                </li>
            </ul>
        </div>
    );
}

export default Footer;
